"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  small: {
    height: "32px",
    verticalPadding: "7px",
    horizontalPadding: "8px",
    tooltipVerticalOffset: 3,
    tooltipHorizontalOffset: 1
  },
  medium: {
    height: "40px",
    verticalPadding: "12px",
    horizontalPadding: "11px",
    tooltipVerticalOffset: 6,
    tooltipHorizontalOffset: 4
  },
  large: {
    height: "48px",
    verticalPadding: "15px",
    horizontalPadding: "13px",
    tooltipVerticalOffset: 10,
    tooltipHorizontalOffset: 6
  }
};
exports.default = _default;